var _style, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "right-white_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".right-white_svg__st7{fill:none;stroke:#fff;stroke-width:65;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M782.4 512H310.6M533.3 249l263 263-263 263"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 512,
    r: 31.3,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightWhite);
export default ForwardRef;